import { Link, useSearchParams } from "react-router-dom";
import { parent_routes } from "../../../router/all_routes";
import { useAcademicYear } from "../../../../core/common/context/AcademicYearContext";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { getAllEvaluationPeriodByLevel } from "../../../../api/generalParam";
import { getStudentExamPlanning } from "../../../../api/planningExam";
import { useChildrenDetails } from "../../../../core/common/context/ChildrenDetailsContext";
import { ExtendHeaderPageComponent } from "../parentDashBoard";
import NoRegistratedAlert from "../noRegistratedAlert";
// import "./index.css"

interface Exam {
  id: string;
  date_exam: string;
  sessionStart: string;
  sessionEnd: string;
  Subject?: {
    label: string;
  };
  Classroom?: {
    label: string;
  };
}

const StudentExamList = () => {
  const routes = parent_routes;
  const [searchParams, setSearchParams] = useSearchParams();
  const periodIdFromUrl = searchParams.get("periodId");

  const { childrenDetails, selectedChild, setSelectedChild } =
    useChildrenDetails();
  const [selectedChildInfos, setSelectedChildInfos] = useState<any>();

  const { selectedYear } = useAcademicYear();

  //Initialisation des state utilisés
  const [allExams, setAllExams] = useState<any[]>([]);
  const [allEvaluationPeriod, setAllEvaluationPeriod] = useState<any[]>([]);
  const [selectedEvaluationPeriod, setSelectedEvaluationPeriod] =
    useState<any>(null);

  const getExamStatus = (exam: Exam) => {
    const now = new Date();
    const start = new Date(`${exam.date_exam}T${exam.sessionStart}`);
    const end = new Date(`${exam.date_exam}T${exam.sessionEnd}`);

    if (now < start) {
      return {
        label: "A venir",
        color: "#4A6CF7",
        bg: "#EAF0FF",
      };
    }

    if (now >= start && now <= end) {
      return {
        label: "En cours",
        color: "#F59E0B",
        bg: "#FFF4DB",
      };
    }

    return {
      label: "Termine",
      color: "#22C55E",
      bg: "#EAFBF0",
    };
  };

  const ExamItem = ({ exam }: { exam: Exam }) => {
    const status = getExamStatus(exam);
    const detailUrl = selectedEvaluationPeriod?.id
      ? `/childExam/${exam.id}?periodId=${selectedEvaluationPeriod.id}`
      : `/childExam/${exam.id}`;

    // charger les informations detwilles de l'enfant selectionner
    useEffect(() => {
      const matchedChild = childrenDetails.find(
        (c: any) => c.id === selectedChild,
      );
      // console.log("Matched !: ", matchedChild);
      if (matchedChild) setSelectedChildInfos(matchedChild);
    }, [selectedChild, childrenDetails]);
    return (
      <Link to={detailUrl} style={styles.examCardLink}>
        <div style={styles.examCard}>
          <div
            style={{ ...styles.leftBorder, backgroundColor: status.color }}
          ></div>

          <div style={styles.examContent}>
            <div style={styles.examHeader}>
              <h3 style={styles.subject}>{exam?.Subject?.label}</h3>
              <span
                style={{
                  ...styles.statusBadge,
                  color: status.color,
                  backgroundColor: status.bg,
                }}
              >
                {status.label}
              </span>
            </div>
            <p style={styles.details}>
              {formatDate(exam.date_exam)} • {exam.sessionStart} -{" "}
              {exam.sessionEnd}
            </p>
            <p style={styles.room}>{exam?.Classroom?.label}</p>
          </div>

          <div style={styles.arrow}>
            <i className="ti ti-chevron-right me-2" />
          </div>
        </div>
      </Link>
    );
  };

  const sortPeriodsByDate = (periods: any[]) =>
    [...periods].sort(
      (a, b) =>
        new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
    );

  const getDefaultEvaluationPeriod = (periods: any[]) => {
    if (!periods.length) return null;

    const sortedPeriods = sortPeriodsByDate(periods);
    const today = new Date();

    const currentPeriod = sortedPeriods.find((period) => {
      const start = new Date(period.startDate);
      const end = new Date(period.endDate);
      return today >= start && today <= end;
    });

    if (currentPeriod) return currentPeriod;

    return [...sortedPeriods].sort(
      (a, b) => new Date(b.endDate).getTime() - new Date(a.endDate).getTime(),
    )[0];
  };

  const fetchPeriods = async () => {
    if (!selectedChildInfos?.class?.Level?.id) {
      setAllEvaluationPeriod([]);
      setSelectedEvaluationPeriod(null);
      return;
    }
    try {
      const response = await getAllEvaluationPeriodByLevel(
        selectedChildInfos?.class?.Level?.id,
      );
      const periods = response.data || [];

      const sortedPeriods = sortPeriodsByDate(periods);
      setAllEvaluationPeriod(sortedPeriods);

      if (sortedPeriods.length > 0) {
        const matchedPeriodFromUrl = periodIdFromUrl
          ? sortedPeriods.find((period: any) => period.id === periodIdFromUrl)
          : null;

        setSelectedEvaluationPeriod(
          matchedPeriodFromUrl || getDefaultEvaluationPeriod(sortedPeriods),
        );
      }
    } catch (error: any) {
      // console.log("erreur de chargement des périodes : ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
      // Option: reset les periodes en cas d'erreur
      setAllEvaluationPeriod([]);
    }
  };

  const fetchExams = async () => {
    if (!selectedChildInfos?.class?.id) {
      setAllExams([]);
      return;
    }
    try {
      const response = await getStudentExamPlanning(
        selectedChildInfos?.id,
        selectedChildInfos?.class?.id,
        selectedEvaluationPeriod?.id,
        null,
      );
      setAllExams(response.data || []);
      // console.log("Examens chargés : ", response.data);
    } catch (error: any) {
      // console.log("erreur de chargement des examens : ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
      setAllExams([]);
    }
  };

  // charger les informations detwilles de l'enfant selectionner
  useEffect(() => {
    const matchedChild = childrenDetails.find(
      (c: any) => c.id === selectedChild,
    );
    console.log("Matched !: ", matchedChild);
    if (matchedChild) setSelectedChildInfos(matchedChild);
  }, [selectedChild, childrenDetails]);

  useEffect(() => {
    // On attend que selectedYear soit défini
    if (!selectedYear?.id) return;
    fetchPeriods();
  }, [selectedYear, periodIdFromUrl, selectedChildInfos]);

  useEffect(() => {
    // On attend que selectedYear soit défini
    if (
      !selectedChildInfos?.class?.id ||
      !selectedChildInfos?.id ||
      !selectedEvaluationPeriod?.id ||
      selectedChildInfos?.academicYear?.id !== selectedYear?.id
    )
      return;
    fetchExams();
  }, [selectedYear, selectedEvaluationPeriod, selectedChildInfos]);

  useEffect(() => {
    if (!selectedEvaluationPeriod?.id) return;

    setSearchParams({ periodId: selectedEvaluationPeriod.id });
  }, [selectedEvaluationPeriod?.id, setSearchParams]);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const formatted = new Intl.DateTimeFormat("fr-FR", {
      weekday: "long",
      day: "2-digit",
      month: "long",
      year: "numeric",
    }).format(date);

    return formatted.replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const currentPeriodIndex = allEvaluationPeriod.findIndex(
    (period) => period.id === selectedEvaluationPeriod?.id,
  );

  const goPrevPeriod = () => {
    if (currentPeriodIndex <= 0) return;
    setSelectedEvaluationPeriod(allEvaluationPeriod[currentPeriodIndex - 1]);
  };

  const goNextPeriod = () => {
    if (
      currentPeriodIndex < 0 ||
      currentPeriodIndex >= allEvaluationPeriod.length - 1
    )
      return;
    setSelectedEvaluationPeriod(allEvaluationPeriod[currentPeriodIndex + 1]);
  };

  const selectedPeriodLabel = selectedEvaluationPeriod
    ? `Examens du ${selectedEvaluationPeriod.label}`
    : "Aucune période";

  const getExamStartDate = (exam: Exam) =>
    new Date(`${exam.date_exam}T${exam.sessionStart}`).getTime();

  const sortedExams = [...allExams].sort(
    (a: Exam, b: Exam) => getExamStartDate(a) - getExamStartDate(b),
  );

  const upcomingAndOngoingExams = sortedExams.filter((exam: Exam) => {
    const status = getExamStatus(exam);
    return status.label === "A venir" || status.label === "En cours";
  });

  const pastExams = sortedExams.filter(
    (exam: Exam) => getExamStatus(exam).label === "Termine",
  );

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Examens</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.parentDashboard}>Accueil</Link>
                  </li>
                  <li className="breadcrumb-item">
                    {selectedChildInfos?.class?.Level?.abbreviation}{" "}
                    {selectedChildInfos?.class?.label}
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Examens
                  </li>
                </ol>
              </nav>
            </div>
            <ExtendHeaderPageComponent
              childrenDetails={childrenDetails}
              activeStudent={selectedChild}
              setSelectedChild={setSelectedChild}
              handleClick={(selectedChild: any) =>
                setSelectedChild(selectedChild)
              }
            />
          </div>
          {/* /Page Header */}

          <div className="d-flex align-items-center justify-content-center gap-2 mt-0 mb-3">
            <button
              type="button"
              className="btn btn-sm btn-light"
              onClick={goPrevPeriod}
              disabled={currentPeriodIndex <= 0}
            >
              <i className="ti ti-chevron-left" />
            </button>

            <h5 className="mb-0 text-center">{selectedPeriodLabel}</h5>

            <button
              type="button"
              className="btn btn-sm btn-light"
              onClick={goNextPeriod}
              disabled={
                currentPeriodIndex < 0 ||
                currentPeriodIndex >= allEvaluationPeriod.length - 1
              }
            >
              <i className="ti ti-chevron-right" />
            </button>
          </div>

          {selectedChildInfos?.academicYear?.id !== selectedYear?.id ? (
            <NoRegistratedAlert />
          ) : (
            <div style={styles.container}>
              <div style={styles.sectionBlock}>
                <h2 style={styles.sectionTitle}>A venir et en cours</h2>
                {upcomingAndOngoingExams.length > 0 ? (
                  upcomingAndOngoingExams.map((exam: Exam) => (
                    <ExamItem key={exam.id} exam={exam} />
                  ))
                ) : (
                  <div style={styles.emptyState}>
                    <div style={styles.emptyStateIcon}>
                      <i className="ti ti-calendar-off" />
                    </div>
                    <div style={styles.emptyStateTitle}>
                      Aucun examen a venir
                    </div>
                    <div style={styles.emptyStateText}>
                      Aucun examen n'est programme ou en cours pour cette
                      periode.
                    </div>
                  </div>
                )}
              </div>

              <div style={styles.sectionBlock}>
                <h2 style={styles.sectionTitle}>Examens passes</h2>
                {pastExams.length > 0 ? (
                  pastExams.map((exam: Exam) => (
                    <ExamItem key={exam.id} exam={exam} />
                  ))
                ) : (
                  <div style={styles.emptyState}>
                    <div style={styles.emptyStateIcon}>
                      <i className="ti ti-history" />
                    </div>
                    <div style={styles.emptyStateTitle}>Aucun examen passe</div>
                    <div style={styles.emptyStateText}>
                      Aucun examen deja termine n'est disponible pour cette
                      periode.
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default StudentExamList;

const styles = {
  examCardLink: {
    textDecoration: "none",
    color: "inherit",
    display: "block",
  },
  arrow: {
    marginLeft: "auto",
    display: "flex",
    alignItems: "center",
    fontSize: 20,
    color: "#6c757d",
  },

  container: {
    padding: "10px",
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#f5f6fa",
    minHeight: "100vh",
  },
  sectionBlock: {
    marginBottom: "22px",
  },
  sectionTitle: {
    marginBottom: "10px",
    fontSize: "13px",
    fontWeight: 700,
    textTransform: "uppercase" as const,
    letterSpacing: "0.04em",
    color: "#6b7280",
  },
  emptyState: {
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    padding: "18px 16px",
    fontSize: "14px",
    color: "#6b7280",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center" as const,
    gap: "6px",
  },
  emptyStateIcon: {
    width: "42px",
    height: "42px",
    borderRadius: "999px",
    backgroundColor: "#EEF2FF",
    color: "#4A6CF7",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
  },
  emptyStateTitle: {
    fontSize: "14px",
    fontWeight: 700,
    color: "#374151",
  },
  emptyStateText: {
    fontSize: "13px",
    color: "#6B7280",
    maxWidth: "320px",
    lineHeight: 1.5,
  },
  examCard: {
    display: "flex",
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    marginBottom: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    overflow: "hidden",
  },
  leftBorder: {
    width: "6px",
    backgroundColor: "#4A6CF7",
  },
  examContent: {
    padding: "12px",
    flex: 1,
  },
  examHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    marginBottom: "6px",
  },
  subject: {
    margin: 0,
    fontSize: "16px",
  },
  statusBadge: {
    fontSize: "12px",
    fontWeight: 600,
    padding: "4px 10px",
    borderRadius: "999px",
    whiteSpace: "nowrap" as const,
  },
  details: {
    margin: "0",
    fontSize: "14px",
    color: "#555",
  },
  room: {
    margin: "4px 0 0 0",
    fontSize: "14px",
    color: "#777",
  },
};
